<template>
  <div class="personal">
    <!-- <van-nav-bar title="修改昵称" fixed >
      <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: .25rem" @click="goBack"></van-icon>
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar> -->
    <GlobTopNav title="修改昵称"></GlobTopNav>

    <div class="van-content">
      <van-cell-group>
        <div class="van-cell van-hairline nicknameCont">
          <!--<van-field style="padding: 0" v-model="nicknameIn" placeholder="请输入昵称" />-->
          <van-field style="padding: 0" v-model="nicknameIn" placeholder="请输入昵称" />
        </div>
      </van-cell-group>
      <van-cell-group style="background: transparent">
        <van-cell style="background: transparent">
          <van-button size="large" class="save" @click="nicknameConfirm()"> 保 存 </van-button>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import store from './../../../vuex/store'
export default {
  name: 'index',
  data() {
    return {
      nicknameIn: '',
      len: 0
    }
  },
  methods: {
    goBack: function () {
      history.back(-1)
    },
    onClickRight() {
      console.log('按钮')
    },
    getByteLen: function (val) {
      //限制24个字符
      var _this = this
      for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i)
        if (a.match(/[^\x00-\xff]/gi) != null) {
          _this.len += 2
        } else {
          _this.len += 1
        }
      }
      return _this.len
    },
    nicknameConfirm: function () {
      var isUser = localStorage.getItem('BLHuser')
      var mallid = localStorage.getItem('mallid')
      this.len = 0
      this.getByteLen(this.nicknameIn)
      if (this.len < 24 && this.len > 0) {
        this.$api.post(
          'user/user/updatename',
          { id_example: mallid, token_user: isUser, name: this.nicknameIn },
          res => {
            if (res.data.code == '100') {
              this.$store.commit('userInfo')
              this.$toast(res.data.message)
              history.back(-1)
            } else {
              this.$toast(res.data.message)
            }
          }
        )
      } else if (this.nicknameIn == '') {
        this.$dialog
          .alert({
            title: '提示',
            message: '请输入昵称！'
          })
          .then(() => {
            // on close
          })
      } else {
        this.$dialog
          .alert({
            title: '提示',
            message: '昵称必须小于24个字符！'
          })
          .then(() => {
            // on close
          })
      }
    },
    getDatas: function () {
      var isUser = localStorage.getItem('BLHuser')
      var mallid = localStorage.getItem('mallid')
      this.$api.post('/user/user/info', { id_example: mallid, token_user: isUser }, res => {
        if (res.data.code == '100') {
          if (res.data.data.user_name != '') {
            this.nicknameIn = res.data.data.user_name
          }
        } else {
          this.$toast(res.data.message)
        }
      })
    }
  },
  mounted() {
    this.getDatas()
  }
}
</script>

<style lang="less" scoped>
.personal {
  min-height: 100vh;
  background-color: #f5f5f5;

  .save {
    width: 100%;
    height: 0.96rem;
    background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
    border-radius: 0.48rem;
    font-size: .3rem;
    color: #ffffff;
    line-height: .42rem;
  }

  .van-content {
    width: 100vw;
  }
  .nicknameCont.van-cell::after {
    bottom: -0.22rem !important;
  }
  .nicknameinput {
    width: 2.5rem;
  }
  .van-cell__value {
    color: #ffffff !important;
    span {
      color: #ffffff !important;
    }
  }
  .van-cell-group {
    background: #fff;
    // margin-top: 0.1rem;
    .van-cell {
      padding: 0.4rem 0.3rem;
    }
    .van-cell:not(:last-child)::after {
      left: 0;
    }

    .userheaderbox {
      .van-cell__title span,
      .van-icon {
        line-height: 0.5rem;
      }

      .userheader {
        line-height: 0.5rem;
        display: inline-block;
        vertical-align: top;
        width: 0.5rem;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 0.5rem;
          height: 0.5rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/personal/changename.vue